import { languageMap } from ".."

languageMap["dns-zone"] = languageMap["dns-zone-file"] = {
	comments: {
		line: ";",
	},
}
